import React, { useMemo, useState } from 'react';
import { Button } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';
import WorkIcon from '@mui/icons-material/Work';
import CachedTwoToneIcon from '@mui/icons-material/CachedTwoTone';
import { useSnackbar } from 'notistack';
import { useDeleteReviewPolicyMutation } from '../../../../api/preHQ';

export const CRPoliciesMenu = ({ Component, row, handleAction }) => {
    const [actionType, setActionType] = useState();
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    const [deleteReviewPolicy, { isLoading: isDeleteLoading }] = useDeleteReviewPolicyMutation();

    const handleDelete = async () => {
        setActionType();
        const bodyFormData = new FormData();
        bodyFormData.append('id', row.id);
        try {
            const response = await deleteReviewPolicy(bodyFormData).unwrap();
            if (!response) return;
            if (response?.status === 'ERROR') throw new Error(response?.message);
            enqueueSnackbar(response?.message, {
                variant: 'success',
            });
            handleAction();
        } catch (err) {
            if (err?.statusCode === 400) enqueueSnackbar(err?.data?.message, { variant: 'error' });
            else enqueueSnackbar(err?.message || 'Failed to delete change request policy.', { variant: 'error' });
        }
    };

    const dialogContent = useMemo(() => {
        if (actionType === 'delete')
            return {
                title: 'Delete Change Policy',
                confirmation: `Are you sure you want to delete this Change Policy?`,
                actions: (
                    <React.Fragment>
                        <Button size="large" onClick={() => setActionType()}>
                            Cancel
                        </Button>
                        <Button size="large" variant="contained" onClick={handleDelete}>
                            Delete
                        </Button>
                    </React.Fragment>
                ),
            };
    }, [actionType]);

    const actionItems = [
        {
            label: 'Modify Policy',
            type: 'modify_policy',
            icon: <EditIcon />,
            onClick: () => navigate(`/client/reviewrequest/reviewpolicies/modify/${row.id}`),
            permissions: ['ROLE_BASE_PERMISSION_PRE_HQ_MODIFY_REVIEW_POLICY'],
        },
        {
            label: 'Delete',
            type: 'delete',
            icon: <DeleteIcon />,
            onClick: (action) => setActionType(action.type),
            permissions: ['ROLE_BASE_PERMISSION_PRE_HQ_DELETE_REVIEW_POLICY'],
        },
        // {
        //     label: 'View Mapped Positions',
        //     type: 'view_mapped_positions',
        //     icon: <WorkIcon />,
        //     onClick: () => navigate(`/client/reviewrequest/reviewpolicies/mappedpositions/view/${row.id}`),
        //     permissions: ['ROLE_BASE_PERMISSION_RECRUIT_INDEX_VIEW_POSITIONS_MAPPED_TO_CHANGE_REQUEST_POLICY'],
        // },
        // {
        //     label: 'Update Mapped Positions',
        //     type: 'update_mapped_positions',
        //     icon: <CachedTwoToneIcon />,
        //     onClick: () => navigate(`/client/reviewrequest/reviewpolicies/mappedpositions/update/${row.id}`),
        //     permissions: ['ROLE_BASE_PERMISSION_RECRUIT_INDEX_BULK_UPDATE_POSITION_CHANGE_REQUEST_POLICY_MAPPINGS'],
        // },
    ];

    return <Component actions={actionItems} dialog={dialogContent} onDialogClose={() => setActionType()} />;
};
